(function () {
  'use strict';
  function centsToPrice(cents) { return cents / 100; }
  function calculatePrice(basePriceCents, quantity) {
    let discountPercent = quantity >= 3 ? 75 : quantity === 2 ? 30 : 0;
    let total = 0;
    for (let i = 0; i < quantity; i++) {
      if (i === 0) { total += basePriceCents; }
      else { total += Math.max(Math.floor(basePriceCents * (1 - discountPercent / 100)), 0); }
    }
    return total;
  }
  function formatMoney(cents, currencySymbol) { return currencySymbol + centsToPrice(cents).toFixed(2); }
  function getCurrencySymbol() {
    const el = document.querySelector('.price-item--regular, .product__price, [data-currency]');
    if (el) { const m = el.textContent.trim().match(/[^\d.,\s]+/); return m ? m[0] : '$'; }
    return '$';
  }
  function initBundleSelector(container) {
    if (!container) return;
    const optionButtons = container.querySelectorAll('.bundle-option');
    const priceElement = container.querySelector('.bundle-price');
    const addButton = container.querySelector('.bundle-add');
    const productPriceEl = document.querySelector('.price-item--regular, .product__price, [data-product-price]');
    let basePriceCents = 0;
    if (productPriceEl) {
      const numeric = parseFloat(productPriceEl.textContent.trim().replace(/[^0-9.]/g, ''));
      if (!isNaN(numeric)) basePriceCents = Math.round(numeric * 100);
    }
    if (!basePriceCents && container.dataset.basePrice) basePriceCents = parseInt(container.dataset.basePrice, 10);
    const currencySymbol = getCurrencySymbol();
    let selectedQuantity = 1;
    function updatePrice(quantity) {
      if (!priceElement) return;
      const totalPriceCents = calculatePrice(basePriceCents, quantity);
      const discountPercent = quantity >= 3 ? 75 : quantity === 2 ? 30 : 0;
      let html = '';
      if (quantity > 1) html += '<span class="price-original">' + formatMoney(basePriceCents * quantity, currencySymbol) + '</span>';
      html += '<span class="price-current">' + formatMoney(totalPriceCents, currencySymbol) + '</span>';
      if (discountPercent > 0) html += '<span class="price-badge">' + discountPercent + '% OFF</span>';
      priceElement.innerHTML = html;
      if (addButton) addButton.textContent = 'Add ' + quantity + ' to Cart';
    }
    function selectOption(quantity) {
      selectedQuantity = quantity;
      optionButtons.forEach(function (btn) {
        btn.classList.remove('selected');
        if (parseInt(btn.dataset.quantity, 10) === quantity) btn.classList.add('selected');
      });
      updatePrice(quantity);
    }
    optionButtons.forEach(function (btn) {
      btn.addEventListener('click', function () { selectOption(parseInt(this.dataset.quantity, 10)); });
    });
    if (addButton) addButton.addEventListener('click', function () { addToCart(selectedQuantity); });
    function addToCart(quantity) {
      const form = container.closest('form[data-type="add-to-cart-form"], form[data-product-form], product-form-component');
      if (form) {
        const qtyInput = form.querySelector('input[name="quantity"], [data-quantity-input]');
        if (qtyInput) qtyInput.value = quantity;
      }
      const submitBtn = container.querySelector('[data-product-add-to-cart], .product-form__add-to-cart, button[name="add"]');
      if (submitBtn) submitBtn.click();
    }
    selectOption(1);
    return { updateQuantity: selectOption, getSelectedQuantity: function () { return selectedQuantity; } };
  }
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.skydrift-bundle-selector').forEach(initBundleSelector);
  });
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      const c = event.target.querySelector('.skydrift-bundle-selector');
      if (c) initBundleSelector(c);
    });
    document.addEventListener('shopify:section:reorder', function () {
      document.querySelectorAll('.skydrift-bundle-selector').forEach(initBundleSelector);
    });
  }
  window.SkyDriftBundleSelector = { init: initBundleSelector };
})();
